import { useMutation, useQuery } from "react-query";
import {
	approveOA,
	checkStatusOA,
	consumeOAProductLine,
	deleteOA,
	duplicateOA,
	finishOA,
	getOAConsumptionAvailability,
	getOADocuments,
	getOAList,
	getOALookups,
	rejectOA,
	returnStateOA,
} from "@/api/Planning/oa/oa-api";

export const oaKey = "oa-list";

export function useOAList(filters, options = {}) {
	return useQuery([oaKey, filters], () => getOAList(filters), {
		keepPreviousData: true,
		...options,
	});
}

export function useOADuplicate() {
	return useMutation(duplicateOA);
}

export function useOADocuments() {
	return useMutation(getOADocuments);
}

export function useOAApprove() {
	return useMutation(approveOA);
}

export function useOAReject() {
	return useMutation(rejectOA);
}

export function useOAFinish() {
	return useMutation(finishOA);
}

export function useOAReturnState() {
	return useMutation(returnStateOA);
}

export function useOACheckStatus() {
	return useMutation(checkStatusOA);
}

export function useOADelete() {
	return useMutation(deleteOA);
}

export function useOAConsumptionAvailability(oaId, options = {}) {
	return useQuery(["oa-consumption-availability", oaId], () => getOAConsumptionAvailability(oaId), {
		enabled: Boolean(oaId),
		...options,
	});
}

export function useConsumeOAProductLine() {
	return useMutation(consumeOAProductLine);
}

export function useOALookups(options = {}) {
	return useQuery(["oa-lookups"], () => getOALookups(), {
		staleTime: 5 * 60 * 1000,
		...options,
	});
}
